// extracted by mini-css-extract-plugin
export default {"button":"purple-micro-icon__button___yj33Q purple-micro__button___hc03p purple__button___U+2rn base__button___zT0JW primary__button___frFdc base__button___zT0JW"};